import BasesService from '../../services/api/Bases'
import ability from '@/plugins/ability'

// initial state
const state = {
  bases: {
    data: [],
    loading: false
  }
}

// getters
const getters = {
  bases: state => {
    return state.bases
  },
  filterBasesByCountryId: (state) => (countryId) => {
    return state.bases.data.filter(b => b.country_id === countryId)
  }
}

// actions
const actions = {
  getBasicData({ dispatch }) {
    dispatch('fetchBases')
  },
  async fetchBases({ commit }) {
    if (!ability.can('view', 'Base')) return

    commit('BASES_LOADING', true)

    let bases = await BasesService.fetch()

    commit('BASES_LOADING', false)
    commit('SET_BASES', {
      data: bases
    })
  }
}

// mutations
const mutations = {
  BASES_LOADING(state, value) {
    state.bases.loading = value
  },
  SET_BASES(state, { data }) {
    state.bases.data = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
